import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';

export const fetchTaskSheetSummary = createAsyncThunk(
  'taskSheet/fetchSummary',
  async (params: { dateFrom?: string; dateTo?: string } = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/v1/admin/task-sheet', { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || 'Failed to fetch task sheet summary'
      );
    }
  }
);

export interface TaskSheetDetailParams {
  employeeId: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  customerName?: string;
  articleNo?: string;
}

export const fetchTaskSheetDetail = createAsyncThunk(
  'taskSheet/fetchDetail',
  async (params: TaskSheetDetailParams, { rejectWithValue }) => {
    try {
      const { employeeId, ...queryParams } = params;
      const response = await axiosInstance.get('/v1/admin/task-sheet/detail', {
        params: { employee_uid: employeeId, ...queryParams },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || 'Failed to fetch task sheet detail'
      );
    }
  }
);

export const fetchMyStats = createAsyncThunk(
  'taskSheet/fetchMyStats',
  async (params: { dateFrom?: string; dateTo?: string } = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/v1/employee/my-stats', { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || 'Failed to fetch stats'
      );
    }
  }
);
